import SignatureCanvas from "react-signature-canvas";
import ModalComp from "../modal/ModalComp";
import { Button, Group, Stack } from "@mantine/core";

const DigitalSignature = ({ sigCanvas, visible, onClose, onSave }) => {
  return (
    <ModalComp
      title="Add Signature"
      opened={visible}
      size="530px"
      onClose={onClose}
    >
      <Stack gap="md">
        <SignatureCanvas
          penColor="black"
          ref={sigCanvas}
          backgroundColor="#f4f4f4"
          minWidth={1} // thinner line
          canvasProps={{ width: 500, height: 200, className: "sigCanvas" }}
        />

        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={() => sigCanvas?.current?.clear()}>
            Clear
          </Button>
          <Button
            onClick={() => {
              onSave(sigCanvas?.current?.toDataURL());
              onClose();
            }}
          >
            Save
          </Button>
        </Group>
      </Stack>
    </ModalComp>
  );
};

export default DigitalSignature;
